<template>
  <div style="width: 100%">
    <div class="outsideBox">
      <div class="insideBox">
        <baidu-map
          class="bm-view"
          :center="center"
          :zoom="zoom"
          :scroll-wheel-zoom="true"
          @ready="handler"
        >
          <!-- animation:标点跳动，position:经纬度 -->
          <bm-marker
            :position="{ lng: 118.70257, lat: 32.190216 }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
          <!-- 提示框 -->
          <!-- <bm-label
            content="南京华晟医学实验室"
            :labelStyle="{color: 'red', fontSize : '12px'}"
            :offset="{width: -35, height: 30}"
        />-->
        </baidu-map>
        <div class="text">
          <el-row class="address-title"
            >南京江河华晟医学检验实验室有限公司</el-row
          >
          <el-row class="address-content"
            >地址：南京市江北新区新锦湖路3-1号中丹生态生命科学产业园二期C座4层、D座4层</el-row
          >
          <el-row class="address-content">电话：400-894-5099</el-row>
          <el-row class="address-content address-bottom"
            >邮箱：hwason@hwason.cn</el-row
          >
        </div>
      </div>
    </div>
    <div class="outsideBox">
      <div class="insideBox" style="top: 50%">
        <baidu-map
          class="bm-view"
          :center="centerTwo"
          :zoom="zoomTwo"
          :scroll-wheel-zoom="true"
          @ready="handlerTwo"
        >
          <!-- animation:标点跳动，position:经纬度 -->
          <bm-marker
            :position="{ lng: 118.920448, lat: 31.94822 }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
          <!-- 提示框 -->
          <!-- <bm-label
            content="南京华晟医学实验室"
            :labelStyle="{ color: 'red', fontSize: '12px' }"
            :offset="{ width: -35, height: 30 }"
          /> -->
        </baidu-map>
        <div class="text">
          <el-row class="address-title">南京华晟医学检验实验室有限公司</el-row>
          <el-row class="address-content"
            >地址：江苏省南京市江宁区乾德路2号</el-row
          >
          <el-row class="address-content">电话：400-894-5099</el-row>
          <el-row class="address-content address-bottom"
            >邮箱：hwason@hwason.cn</el-row
          >
        </div>
      </div>
    </div>
    <div class="outsideBox">
      <div class="insideBox" style="top: 50%">
        <baidu-map
          class="bm-view"
          :center="centerChs"
          :zoom="zoomChs"
          :scroll-wheel-zoom="true"
          @ready="handlerChs"
        >
          <!-- animation:标点跳动，position:经纬度 -->
          <bm-marker
            :position="{ lng: 112.892776, lat: 28.128056 }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
          <!-- 提示框 -->
          <!-- <bm-label
            content="南京华晟医学实验室"
            :labelStyle="{ color: 'red', fontSize: '12px' }"
            :offset="{ width: -35, height: 30 }"
          /> -->
        </baidu-map>
        <div class="text">
          <el-row class="address-title"
            >长沙江河华晟医学检验实验室有限公司</el-row
          >
          <el-row class="address-content"
            >地址：湖南省长沙市岳麓区学士街道学士路336号</el-row
          >
          <el-row class="address-content">电话：400-894-5099</el-row>
          <el-row class="address-content address-bottom"
            >邮箱：hwason@hwason.cn</el-row
          >
        </div>
      </div>
    </div>
    <div class="outsideBox">
      <div class="insideBox" style="top: 50%">
        <baidu-map
          class="bm-view"
          :center="centerZhzhou"
          :zoom="zoomZhzhou"
          :scroll-wheel-zoom="true"
          @ready="handlerZhzhou"
        >
          <!-- animation:标点跳动，position:经纬度 -->
          <bm-marker
            :position="{ lng: 113.794619, lat: 34.726409 }"
            :dragging="true"
            animation="BMAP_ANIMATION_BOUNCE"
          ></bm-marker>
          <!-- 提示框 -->
          <!-- <bm-label
            content="南京华晟医学实验室"
            :labelStyle="{ color: 'red', fontSize: '12px' }"
            :offset="{ width: -35, height: 30 }"
          /> -->
        </baidu-map>
        <div class="text">
          <el-row class="address-title"
            >郑州江河华晟医学检验实验室有限公司</el-row
          >
          <el-row class="address-content"
            >地址：河南省郑州市河南自贸试验区郑州片区(经开)第十三大街3号</el-row
          >
          <el-row class="address-content">电话：400-894-5099</el-row>
          <el-row class="address-content address-bottom"
            >邮箱：hwason@hwason.cn</el-row
          >
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: '6Q7BAAVsM1sUAskGmeu1IbwTp9agF7TY',
})
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 6,
      centerTwo: { lng: 0, lat: 0 },
      zoomTwo: 6,
      centerChs: { lng: 0, lat: 0 },
      zoomChs: 6,
      centerZhzhou: { lng: 0, lat: 0 },
      zoomZhzhou: 6,
    }
  },
  methods: {
    handler({ BMap, map }) {
      // console.log(BMap, map)
      this.center.lng = 118.70257
      this.center.lat = 32.190216
      // 缩放比例
      this.zoom = 17
    },
    handlerTwo({ BMap, map }) {
      // console.log(BMap, map)
      this.centerTwo.lng = 118.920448
      this.centerTwo.lat = 31.94822
      this.zoomTwo = 17
    },
    handlerChs({ BMap, map }) {
      this.centerChs.lng = 112.892776
      this.centerChs.lat = 28.128056
      this.zoomChs = 17
    },
    handlerZhzhou({ BMap, map }) {
      this.centerZhzhou.lng = 113.794619
      this.centerZhzhou.lat = 34.726409
      this.zoomZhzhou = 17
    },
  },
}
</script>

<style lang="scss" scoped>
.outsideBox {
  width: 100%;
  height: 805px;
  background-color: #edf5ff;
  position: relative;
  box-sizing: border-box;
  border-bottom: 1px solid #999999;
  display: flex;
  justify-content: center;
  align-items: center;
  .insideBox {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    width: 88%;
    height: 80%;
    // margin: 20px auto;
    border: 1px solid transparent;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
    background-color: #e5f0f8;
    font-weight: 600;
    box-sizing: border-box;
    // border: 2px dashed orange;
    display: flex;
    justify-content: space-between;
    .bm-view {
      width: 78%;
      height: 100%;
      // border: 1px solid #c2c3c3;
    }
    .text {
      flex: 1;
      box-sizing: border-box;
      // border: 1px solid red;
      display: flex;
      flex-direction: column;
      align-items: center;
      // width: 22%;
      // border: 2px solid rgb(9, 255, 0);
      // position: absolute;
      // right: 0px;
      // top: 34px;
      .address-title {
        margin: 70px 0 54px 0;
        font-size: 20px;
        color: #363636;
      }
      .address-content {
        width: 300px;
        // border: 1px solid red;
        word-wrap: break-word;

        word-break: normal;
        margin: 30px 0 20px 0;
        font-size: 15px;
        color: #363636;
      }
      .address-bottom {
        margin: 30px 0 20px 0;
        font-size: 15px;
        color: #363636;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/contact/component/address.vue